// extracted by mini-css-extract-plugin
export const outer = "location-module--outer--1MBOv";
export const sidebar = "location-module--sidebar--2jtQR";
export const sidebarClose = "location-module--sidebar-close--3fdRe";
export const map = "location-module--map--1lyYT";
export const button = "location-module--button--2wwvh";
export const buttonImage = "location-module--button-image--nfxrG";
export const buttonImageRotate = "location-module--button-image-rotate--bRuUr";
export const list = "location-module--list--1DlzW";
export const cardOuter = "location-module--card-outer--1JmhH";
export const imageDiv = "location-module--image-div--3Jb6R";
export const dataDiv = "location-module--data-div--rcu6z";
export const cardName = "location-module--card-name--3uTzE";